export const getIsAlgosListFetching = (state) =>
  state.algosList.list.isFetching;

export const getIsAlgosListErrorMessage = (state) =>
  state.algosList.list.errorMessage;

export const getIsAlgosListRefreshResponse = (state) =>
  state.algosList.refresh.data || {};

export const getIsAlgosListRefresh = (state) =>
  state.algosList.refresh.data.data ? state.algosList.refresh.data.data : [];

export const getIsAlgosListRefreshOk = (state) =>
  state.algosList.refresh.data &&
  state.algosList.refresh.data.status &&
  state.algosList.refresh.data.status === 'success'
    ? true
    : false;

export const getUpdateTime = (state) => state.algosList.refresh.updateTime;

export const getPnlUpdatedAt = (state) => state.algosList.refresh.pnlUpdatedAt;

export const getSelectedDay = (state) => state.algosList.config.selectedDay;

export const getToday = (state) => state.algosList.config.today;

export const getSorting = (state) => state.algosList.config.sorting;

export const getAlgoRefreshFlat = (state) => {
  const data = getIsAlgosListRefresh(state);
  const algos = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];

    if (element?.day === 'ELSE') {
      continue;
    }

    const dayAlgos = element.algos || [];

    algos.push(...dayAlgos);
  }

  return algos;
};

export const getAlgoRefreshSelectedDay = (state) => {
  const day = getSelectedDay(state);
  const { algos = [] } =
    getIsAlgosListRefresh(state).find((d) => d.day === day) || [];

  return algos;
};

export const getAlgoRefreshIdsSelectedDay = (state) => {
  const algos = getAlgoRefreshSelectedDay(state);

  return algos.map((a) => a._id) || [];
};

export const getModalErrors = (state) => state.algosList.config.modalErrors;

export const getTerminateData = (state) => state.algosList.config.terminateData;

export const getDuplicateAlgoData = (state) =>
  state.algosList.config.duplicateAlgoData;

export const getRenameAlgoData = (state) =>
  state.algosList.config.renameAlgoData;

export const getDeleteAlgoData = (state) =>
  state.algosList.config.deleteAlgoData;

export const getFilter = (state) => state.algosList.config.filter;
export const getFilterUpdatedAt = (state) =>
  state.algosList.config.filterUpdatedAt;

export const getBulkSelectionValue = (state) =>
  state.algosList.config.bulkSelectionValue;

export const getBulkDeleteAlgoData = (state) =>
  state.algosList.config.bulkDeleteAlgoData;

export const getBulkDuplicateAlgoData = (state) =>
  state.algosList.config.bulkDuplicateAlgoData;

export const getBulkEnableAlgoData = (state) =>
  state.algosList.config.bulkEnableAlgoData;

export const getBulkDisableAlgoData = (state) =>
  state.algosList.config.bulkDisableAlgoData;

export const getBulkMultiplierAlgoData = (state) =>
  state.algosList.config.bulkMultiplierAlgoData;

export const getBulkMTMModifyAlgoData = (state) =>
  state.algosList.config.bulkMTMModifyAlgoData;

export const getPageLoading = (state) => state.algosList.config.pageLoading;

export const getBulkTerminateAlgoData = (state) =>
  state.algosList.config.bulkTerminateAlgoData;

export const getBulkSqOffTerminateAlgoData = (state) =>
  state.algosList.config.bulkSqOffTerminateAlgoData;

export const getTotalPnlLength = (state) =>
  state.algosList.config.totalPnlLength;

//

export const getClientWiseSqOffTerminateAlgoData = (state) =>
  state.algosList.config.clientWiseSqOffTerminateAlgoData;

export const getClientWiseTerminateAlgoData = (state) =>
  state.algosList.config.clientWiseTerminateAlgoData;

export const getclientWiseSetTargetData = (state) =>
  state.algosList.config.clientWiseSetTargetData;

export const getMassPnl = (state) => state.algosList.config.massPnl;

export const getIsClientIdShow = (state) =>
  state.algosList.config.clientIdShow ? true : false;

export const getIsMtmShow = (state) =>
  state.algosList.config.mtmShow ? true : false;

export const getIsMultiSelectSelected = (state) =>
  state.algosList.config.multiSelectSelected;

export const getShiftPressed = (state) => state.algosList.config.shiftPressed;

// cache
export const getAlgoListDataCached = (state) =>
  state.algosList.refresh.dataCached && state.algosList.refresh.dataCached.data
    ? state.algosList.refresh.dataCached.data
    : [];

export const getAlgoListDataCacheUpdateTime = (state) =>
  state.algosList.refresh.cacheUpdateTime;

export const getAlgoListDataCachedSelectedDay = (state) => {
  const day = getSelectedDay(state);
  const { algos = [] } =
    getAlgoListDataCached(state).find((d) => d.day === day) || [];

  return algos;
};

export const getAlgoListDataCachedIdsSelectedDay = (state) => {
  const algos = getAlgoListDataCachedSelectedDay(state);

  return algos.map((a) => a._id) || [];
};

export const getAlgoListDataCachedFlat = (state) => {
  const data = getAlgoListDataCached(state);
  const algos = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];

    const dayAlgos = element.algos || [];

    algos.push(...dayAlgos);
  }

  return algos;
};
